export default __webpack_public_path__ + "static/media/bot.5557ec67.png";